import React, { Component } from 'react';
import { connect } from 'react-redux';
import {lowestDenom} from '../../../../config';
import './portfolio.css';
import M from 'materialize-css/dist/js/materialize.min.js'
import {setAmount} from '../../../../actions/ui/marketplace';
import {matchOrders} from '../../../../actions/orderbook/matchingEngine';
import {getNEOFee,getBTCFee,getETHFee,getLSKFee,getWAVFee,getNRGFee,getEMBFee,getDAIFee,getUSDTFee} from '../../../../actions/transfers/fees';
import {assets} from '../../../../config';
import {Decimal} from 'decimal.js'

class Portfolio extends Component {
  onChangeAmount(percent){
    let index = this.props.orderType == 'BUY' ? 'denomination' : 'asset';
    let price = this.props.price ? this.props.price : 1;

    let val = new Decimal(this.props[`${this.props.market[index].toLowerCase()}`]).mul(new Decimal(percent)).toNumber();
    if(val >= 0 && this.props.orderType === 'SELL'){
      this.props.setAmount(val,()=>{})
      // this.props.matchOrders();
    }
    if(val >= 0 && this.props.orderType === 'BUY'){
      this.props.setAmount(new Decimal(val).div(new Decimal(price)).toNumber(),()=>{})
      // this.props.matchOrders();
    }
  }
  onChangeAmount100(percent){
    let index = this.props.orderType == 'BUY' ? 'denomination' : 'asset';
    let price = this.props.price ? this.props.price : 1;
    let val = new Decimal(this.props[`${this.props.market[index].toLowerCase()}`]).mul(new Decimal(percent)).toNumber()

    this.props[`get${this.props.market[index].toUpperCase()}Fee`](val,()=>{
      setTimeout(()=>{
        val = (val - this.props.fee)
        if(val >= 0 && this.props.orderType === 'SELL'){
          this.props.setAmount(val,()=>{})
          // this.props.matchOrders();
        }
        if(val >= 0 && this.props.orderType === 'BUY'){
          this.props.setAmount(new Decimal(val).div(new Decimal(price)).toNumber(),()=>{})
          // this.props.matchOrders();
        }
      },100);
    });
  }
  render() {
    let index = this.props.orderType == 'BUY' ? 'denomination' : 'asset';
    let bal = this.props[`${this.props.market[index].toLowerCase()}`]
    if(!bal) bal = 0;
    let {denomination,asset} = this.props.market;

    let display = this.props.wallet && !(this.props.wallet[denomination.toLowerCase()] && this.props.wallet[asset.toLowerCase()]) ? 'none' : '';

    return (
      <div className='row'>
        <div id='placeOrderBal' className='col s6' >
          <p style={{margin:0,fontSize:'10px'}}>Bal: {`${bal.toString().substring(0,16)} ${this.props.market[index].replace('NRG','OL')}`}</p>
        </div>
        <div id='placeOrderNums' className='col s6' style={{display}}>
          <div className='col s3'>
            <p style={{margin:0}} onClick={this.onChangeAmount.bind(this,0.1)}>10%</p>
          </div>
          <div className='col s3'>
            <p style={{margin:0}} onClick={this.onChangeAmount.bind(this,0.25)}>25%</p>
          </div>
          <div className='col s3'>
            <p style={{margin:0}} onClick={this.onChangeAmount.bind(this,0.5)}>50%</p>
          </div>
          <div className='col s3'>
            <p style={{margin:0}} className='tooltipped' data-position="bottom" data-tooltip={`Full Balance - ${this.props.market[index].toUpperCase()} Tx Fee`} onClick={this.onChangeAmount100.bind(this,1)}>Max</p>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let obj = {
    wallet: state.passport.wallet,
    fee: state.passport.fee,
    market: state.ui_marketplace.market,
    orderType: state.ui_marketplace.orderType,
    price: state.ui_marketplace.price,
    amount: state.ui_marketplace.amount,
  }
  let tradeAddresses = state.passport.tradeAddresses;

  assets.map((a)=>{
    if(tradeAddresses[a.toLowerCase()]){
      obj[a.toLowerCase()] = state.passport[a.toLowerCase()][tradeAddresses[a.toLowerCase()]]
      if(!obj[a.toLowerCase()]) obj[a.toLowerCase()] = 0;
      else obj[a.toLowerCase()] = new Decimal(obj[a.toLowerCase()]).toNumber()
    }
  })

  return obj;
}

export default connect(mapStateToProps, {setAmount,matchOrders,getNEOFee,getBTCFee,getETHFee,getLSKFee,getWAVFee,getNRGFee,getEMBFee,getDAIFee,getUSDTFee})(Portfolio);
